import React from "react";
import PageTemplate from "../components/PageTemplate";

const importAll = (context) =>
  context.keys().map((key) => ({
    key,
    src: context(key),
    name: key
      .replace("./", "")
      .replace(/\.[^/.]+$/, "")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim(),
  }));

export default function Sponsorship() {
  const sponsorLogos = importAll(
    require.context("../Sponsor", false, /\.(png|jpe?g|webp|svg|avif)$/i)
  );
  const donorLogos = importAll(
    require.context("../Donors", false, /\.(png|jpe?g|webp|svg|avif)$/i)
  );
  const getDonorLink = (logo) => {
    if (!logo) return null;
    const raw =
      typeof logo.src === "string"
        ? logo.src
        : typeof logo.src?.default === "string"
          ? logo.src.default
          : "";
    const name = `${logo.key || ""} ${logo.name || ""} ${raw}`.toLowerCase();
    if (name.includes("saint_james")) return "https://saintjamesicedtea.com/";
    if (name.includes("waterboy")) return "https://www.waterboy.com/";
    if (name.includes("aspire")) return "https://aspiredrinks.com/";
    if (name.includes("celsius")) return "https://www.celsius.com/";
    if (name.includes("costco")) return "https://www.costco.com/";
    if (name.includes("hrbl")) return "https://hrbl-wellness.com/";
    if (name.includes("joyn")) return "https://www.joynthefun.com/";
    if (name.includes("lmnt")) {
      return "https://drinklmnt.com/?msclkid=f9e90d96b699128e5688641d5544a460&utm_source=bing&utm_medium=cpc&utm_campaign=SEM%20Branded&utm_term=lmnt&utm_content=SEM%20Branded%20LMNT%20-%20EM";
    }
    if (name.includes("logo1")) return "https://www.primefootandanklecare.com/";
    if (name.includes("hiyo")) return "https://drinkhiyo.com/";
    if (name.includes("neuro")) return "https://neurogum.com/";
    if (name.includes("salud")) return "https://tastesalud.com/";
    if (name.includes("cake cafe") || name.includes("delights")) {
      return "https://www.instagram.com/delightsbydiya/";
    }
    if (name.includes("shottys")) return "https://shottys.com/";
    if (name.includes("cinnaholic")) return "https://www.cinnaholic.com/";
    if (name.includes("bubblr")) return "https://www.drinkbubblr.com/";
    if (name.includes("nuun")) return "https://nuunlife.com/";
    if (name.includes("waiakea")) return "https://waiakea.com/";
    if (name.includes("dude-wipes")) return "https://dudewipes.com/";
    if (name.includes("fritolay")) return "https://www.fritolay.com/";
    if (name.includes("onceuponacoconut")) return "https://onceuponacoconut.com/";
    if (name.includes("wegmans")) return "https://www.wegmans.com/";
    if (name.includes("thegoldenprints")) {
      return "https://www.thegoldenprints.com/The_Golden_Prints/shop/home";
    }
    if (name.includes("malabartreats")) return "https://maharajastoreus.com/";
    if (name.includes("prism-patch")) return "https://www.prismpatch.co/";
    if (name.includes("redbull")) return "https://www.redbull.com/us-en/";
    return null;
  };
  const getSponsorLink = (src) => {
    if (typeof src !== "string") return null;
    if (src.includes("0ece5170-0044-4abf-8228-293c80b538e7")) {
      return "https://happydayzusa.com/";
    }
    if (src.includes("Ganga-Indian-Restaurant_FINAL-LOGO")) {
      return "https://www.gangaib.com/";
    }
    if (src.includes("Subworks Logo PNG")) {
      return "https://share.google/PSw1ohhanW1tET8SQ";
    }
    if (src.includes("f9770592-dddf-4a67-890b-3116b31241b3")) {
      return "https://themasalamex.com/";
    }
    return null;
  };

  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-10 sm:py-14 lg:py-18 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in">
            Our Partners
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Sponsors Section */}
      <div className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-cream-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-60 h-60 bg-gradient-to-r from-beach-300 to-seafoam-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-60 h-60 bg-gradient-to-r from-coral-300 to-sand-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-5xl sm:text-6xl md:text-7xl font-text font-bold text-coral mb-4">
              Sponsors
            </h2>
            <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
            {sponsorLogos.map((logo) => {
              const sponsorLink = getSponsorLink(logo.src);
              const content = (
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="max-h-24 sm:max-h-28 lg:max-h-32 w-full object-contain"
                />
              );
              return (
                <div key={logo.src} className="flex items-center justify-center p-2">
                  {sponsorLink ? (
                    <a
                      href={sponsorLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-transform duration-200 hover:scale-105"
                    >
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Donors Section */}
      <div className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-cream-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-60 h-60 bg-gradient-to-r from-peach-300 to-cream-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-60 h-60 bg-gradient-to-r from-sky-300 to-teal-300 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-5xl sm:text-6xl md:text-7xl font-text font-bold text-coral mb-4">
              Donors
            </h2>
            <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
            {donorLogos.map((logo) => {
              const isBubblr =
                typeof logo.src === "string" &&
                logo.src.toLowerCase().includes("bubblr");
              const isHrbl =
                typeof logo.src === "string" &&
                logo.src.includes("HRBL_Primary Logo Orange Green");
              const isCakeCafe =
                typeof logo.src === "string" &&
                logo.src.includes("Red and White Illustrated Cake Cafe Logo");
              const isPrimeFoot =
                typeof logo.src === "string" &&
                logo.src.toLowerCase().includes("logo1");
              const donorLink = getDonorLink(logo);
              const wrapperClass = `flex items-center justify-center ${
                isPrimeFoot
                  ? "p-0 sm:p-1 lg:p-1"
                  : isCakeCafe
                    ? "p-0"
                    : isHrbl
                      ? "p-0 sm:p-1"
                      : isBubblr
                        ? "p-1"
                        : "p-2"
              }`;
              const imageClass = `w-full object-contain ${
                isBubblr
                  ? "max-h-36 sm:max-h-40 lg:max-h-44"
                  : isPrimeFoot
                    ? "max-h-34 sm:max-h-40 lg:max-h-48"
                    : isCakeCafe
                      ? "max-h-32 sm:max-h-40 lg:max-h-48"
                      : isHrbl
                        ? "max-h-28 sm:max-h-32 lg:max-h-36"
                        : "max-h-24 sm:max-h-28 lg:max-h-32"
              }`;
              return donorLink ? (
                <a
                  key={logo.src}
                  href={donorLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${wrapperClass} transition-transform duration-200 hover:scale-105`}
                >
                  <img src={logo.src} alt={logo.name} className={imageClass} />
                </a>
              ) : (
                <div key={logo.src} className={wrapperClass}>
                  <img src={logo.src} alt={logo.name} className={imageClass} />
                </div>
              );
            })}
          </div>
        </div>
      </div>

    </PageTemplate>
  );
}
